(function() {
  'use strict';

  angular.module('remitEventsApp').controller('MainController', function() {});
})();
